<template>
  <div>
    <div
      v-if="
        slotKey === 'news_title' && item.title && getFirstFulfilled(item.title)
      "
      @click="
        $router.push(
          { name: 'news-detail', params: { id: item.id } },
          () => null
        )
      "
    >
      <router-link
        :to="{ name: 'news-detail', params: { id: item.id } }"
        class="td-post-item"
        tag="span"
      >
        <span>{{ getFirstFulfilled(item.title).text }}</span>

        <a-tag v-if="item.title" style="margin-left: 10px">
          {{ lanuagesParams[getFirstFulfilled(item.title).lang].abr }}
        </a-tag>
      </router-link>
    </div>

    <!-- <template v-if="slotKey ==='id'">
      <b>{{ item.id }}</b>
    </template> -->

    <template v-if="slotKey === 'language_support_with_flag' && item.language_support">
      <template v-for="(language_support, key) in item.language_support">
        <a-tag v-if="language_support" :key="key">
          <img
            width="14"
            class="flag-svg__tab"
            :src="contentLanguages[key].flagSrc"
            :alt="key"
          />
          {{ contentLanguages[key].abr }}
        </a-tag>
      </template>
    </template>
    <template v-if="slotKey === 'position' && item.position">
      <b>{{ item.position }}</b>
    </template>
    <template v-if="slotKey === 'title_languages' && item.title">
      <a-tag
        :color="
          Object.keys(toObj(item.title)).length >=
          Object.keys(lanuagesParams).length
            ? 'green'
            : 'volcano'
        "
      >
        <span v-for="(languageSupport, key) in toObj(item.title)" :key="key">
          {{ lanuagesParams[key].abr }}
        </span>
      </a-tag>
      <a-tag v-if="excludedLanguages(item.title).length" color="volcano">
        <span
          v-for="(languageSupport, key) in excludedLanguages(item.title)"
          :key="key"
        >
          {{ lanuagesParams[key].abr }}
        </span>
      </a-tag>
    </template>
    <template v-if="slotKey === 'content_languages'">
      <a-tag
        :color="
          Object.keys(toObj(item.content)).length >=
          Object.keys(lanuagesParams).length
            ? 'green'
            : 'volcano'
        "
      >
        <span v-for="(languageSupport, key) in toObj(item.content)" :key="key">
          {{ lanuagesParams[key].abr }}
        </span>
      </a-tag>
      <a-tag v-if="excludedLanguages(item.content).length" color="volcano">
        <span
          v-for="(languageSupport, key) in excludedLanguages(item.content)"
          :key="key"
        >
          {{ lanuagesParams[key].abr }}
        </span>
      </a-tag>
    </template>
    <template v-if="slotKey === 'created'">
      {{ moment(item).format("LLL") }}
    </template>
    <template v-if="slotKey === 'updated'">
      {{ moment(item).format("LLL") }}
    </template>
    <template v-if="slotKey === 'slug' && item.slug">
      {{ item.slug }}
    </template>
    <template v-if="slotKey === 'language_support' && item.language_support">
      <template>
        <a-tag
          v-if="
            item.language_support &&
            Object.keys(item.language_support).filter(
              (k) => item.language_support[k]
            ).length
          "
          color="green"
        >
          <template v-for="(languageSupport, key) in item.language_support">
            <span v-if="item.language_support[key]" :key="key">
              {{ lanuagesParams[key].abr }}
            </span>
          </template>
        </a-tag>
        <a-tag
          v-if="
            item.language_support &&
            Object.keys(item.language_support).filter(
              (k) => !item.language_support[k]
            ).length
          "
          color="volcano"
        >
          <template v-for="(languageSupport, key) in item.language_support">
            <span v-if="!item.language_support[key]" :key="key">
              <!-- <img
                    width="14"
                    class="flag-svg__tab"
                    :src="lanuagesParams[key].flagSrc"
                    :alt="key"
                                >-->
              {{ lanuagesParams[key].abr }}
            </span>
          </template>
        </a-tag>
        <!-- <a-tag
          v-if="languageSupport"
          :key="key"
        >
          <img
            width="14"
            class="flag-svg__tab"
            :src="lanuagesParams[key].flagSrc"
            :alt="key"
          >
          {{ lanuagesParams[key].abr }}
        </a-tag> -->
      </template>
    </template>
    <template v-if="slotKey === 'category'">
      <a-tag :color="stringToHex(item.category.slug)">
        {{ item.category.title || item.category.slug }}
      </a-tag>
    </template>
    <template v-if="slotKey === 'tag_list'">
      <a-tag v-for="tag in item.tag_list" :key="tag.id" color="green">
        {{ tag.name || tag.id }}
      </a-tag>
    </template>
    <template v-if="slotKey === 'status'">
      <!-- <osg-image :img="item" /> -->
      <a-tag :color="item.status ? 'geekblue' : 'volcano'">
        {{ item.status ? "Опубликован" : "Не опубликован" }}
      </a-tag>
    </template>
    <template v-if="slotKey === 'is_main'">
      <a-tag :color="item.is_main ? 'geekblue' : 'volcano'">
        {{ item.is_main ? "Вкл." : "Выкл." }}
      </a-tag>
    </template>
    <template v-if="slotKey === 'to_slider'">
      <a-badge
        :status="item.is_slider ? 'success' : 'error'"
        :text="item.is_slider ? 'Да' : 'Нет'"
      />
    </template>
    <template v-if="slotKey === 'files_num'">
      {{ Object.keys(item.files).length }}
    </template>
    <template v-if="slotKey === 'views'">
      <a-icon type="eye" />
      {{ item.views }}
    </template>
    <template v-if="item && 'files' in item && slotKey === 'files_size'">
      {{
        bytesToSize(Object.values(item.files).reduce((a, b) => a + b.size, 0))
      }}
    </template>
    <template v-if="slotKey === 'operation'">
      <a-icon
        class="action-btns"
        type="edit"
        @click="
          $router.push(
            { name: 'news-detail', params: { id: item.id } },
            () => null
          )
        "
      />
      <a-popconfirm
        title="Вы действительно хотите удалить?"
        cancel-text="Нет"
        ok-text="Да"
        @confirm="$emit('removeItem', item)"
      >
        <a-icon class="action-btns" style="margin: 0 10px" type="delete" />
      </a-popconfirm>
    </template>
    <slot />
  </div>
</template>

<script>
import { CONTENT_LANGUAGES } from "@/constants"
export default {
  name: "TableCells",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    slotKey: {
      type: String,
      default: () => ""
    }
  },
  data: () => ({
    autocompleteItems: [],
    tag: null,
    optionTags: null,
    selectedTags: [],
    query: "",
    news: [],
    count: 1,
    form: {
      cat_id: null
    },
    formItemLayout: {}
  }),
  computed: {
    contentLanguages: () => CONTENT_LANGUAGES,
    lanuagesParams() {
      return CONTENT_LANGUAGES
    }
  },

  methods: {
    stringToHex(str) {
      if (!str) return ""
      let hash = 0
      if (str.length === 0) return hash
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash)
        hash = hash & hash
      }
      let color = "#"
      for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 255
        color += ("00" + value.toString(16)).substr(-2)
      }
      return color
    },
    toObj(content) {
      if (typeof content == "string") {
        return JSON.parse(content)
      }
      return content
    },
    excludedLanguages(content) {
      if (typeof content == "string") {
        content = Object.keys(JSON.parse(content))
        const difference = Object.keys(this.lanuagesParams).filter(
          (x) => !content.includes(x)
        )
        return difference
      }
      return content
    },

    bytesToSize(bytes) {
      const sizes = ["Bytes", "KB", "MB", "GB", "TB"]
      if (bytes === 0) return "n/a"
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`
    },
    getFirstFulfilled(fields) {
      if (typeof fields == "string") {
        fields = JSON.parse(fields)
      }
      let lang = this.$i18n.locale
      if (!fields) return {}
      if (fields[lang]) {
        return {
          text: fields[lang],
          lang: lang
        }
      } else {
        const lang = Object.keys(fields).find((l) => fields[l])
        if (!lang) {
          return {}
        }
        return {
          text: fields[lang],
          lang: lang
        }
      }
    }
  }
}
</script>
